// Footer.js

import React from "react";
import "./Footer.css";
import footerImage from "../../assets/footerImage.png";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Shipping Section */}
        <div className="footer-section">
          <h3>Multiple Shipping Options</h3>
          <img
            src={footerImage}
            alt="Shipping Options"
            className="footer-image"
          />
        </div>

        {/* Address Section */}
        <div className="footer-section">
          <h3>Address</h3>

          <address>
            <strong>Bangkok (Head Office)</strong><br />
            Newbell International Trading Co., Ltd<br />
            318/31 Soi Sukhumvit 22, Sukhumvit Road<br />
            Kwaeng Klongtoey, Khet Klongtoey<br />
            Bangkok, 10110 Thailand
          </address>

          <div style={{ height: 12 }} />

          <address>
            <strong>China (Yiwu)</strong><br />
            Qu Yuan Xiao Qu, Building No. 5, Gate-2, Room no. 101<br />
            Yiwu City, Zhejiang Province, China
          </address>
        </div>

        {/* Contact Section */}
        <div className="footer-section">
          <h3>Contact</h3>
          <p>
            <strong>Tel (BKK):</strong>{" "}
            <a href="tel:+6622041645">+66-2204-1645</a><br />

            <strong>Mobile (Bangkok):</strong>{" "}
            <a href="tel:+66818403643">+66 818403643</a>{" "}
            &nbsp;|&nbsp;
            <a href="tel:+66988540410">+66 988540410</a><br />

            <strong>Email (Bangkok):</strong><br />
            <a href="mailto:kunal@newbell.net">kunal@newbell.net</a><br />
            <a href="mailto:varun@newbell.net">varun@newbell.net</a>
          </p>

          <div style={{ height: 8 }} />

          <p>
            <strong>China Contact</strong><br />
            <strong>Tel:</strong> (579) 85582439, 85582440, 85582441<br />
            <strong>Fax:</strong> (579) 85582442<br />
            <strong>Mobile:</strong> <a href="tel:+8613857965630">+86-13857965630</a>
          </p>

          <div style={{ marginTop: 12 }}>
            {/* Instagram link (replaces Facebook) */}
            <a
              href="https://www.instagram.com/newbell_yiwu?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Newbell Instagram"
              title="Instagram"
              style={{ display: "inline-flex", alignItems: "center", gap: 8, color: "inherit", textDecoration: "none" }}
            >
              {/* simple Instagram SVG icon */}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden focusable="false" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.4" fill="none"/>
                <path d="M12 7.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z" stroke="currentColor" strokeWidth="1.4" fill="none"/>
                <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor"/>
              </svg>
              <span>Follow us on Instagram</span>
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Newbell International. All rights reserved.</p>
        <p style={{ marginTop: 8, fontSize: "0.95rem" }}>
          <strong>Bangkok contacts:</strong>&nbsp;
          <a href="tel:+66818403643" style={{ color: "inherit", textDecoration: "none" }}>+66 818403643</a>,
          &nbsp;<a href="tel:+66988540410" style={{ color: "inherit", textDecoration: "none" }}>+66 988540410</a>
          &nbsp;•&nbsp;
          <a href="mailto:kunal@newbell.net" style={{ color: "inherit", textDecoration: "none" }}>kunal@newbell.net</a>,
          &nbsp;<a href="mailto:varun@newbell.net" style={{ color: "inherit", textDecoration: "none" }}>varun@newbell.net</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;